import { cloudinaryImage } from '../cloudinary'

export const COMPANY_NAME = 'Qwick'
export const COMPANY_URL = 'https://www.qwick.com'
export const COMPANY_LOGO = cloudinaryImage('logos/qwick-wordmark').toURL()

export const appDownloadLinks = {
  ios: 'https://apps.apple.com/us/app/qwick-for-professionals/id1458652766',
  google:
    'https://play.google.com/store/apps/details?id=com.qwickmobile&hl=en_US',
}

export const businessAppDownloadLinks = {
  ios: 'https://apps.apple.com/us/app/qwick-for-business/id1484374980',
  google:
    'https://play.google.com/store/apps/details?id=com.qwickmobilebusiness&hl=en_US',
}

export const socialMediaLinks = {
  facebook: 'https://www.facebook.com/QwickShifts/',
  instagram: 'https://www.instagram.com/qwickshifts/',
  linkedin: 'https://www.linkedin.com/company/qwick/',
  linkedInJobs: 'https://www.linkedin.com/company/qwick/jobs',
}

export const ExternalGigproLinks = {
  login: process.env.GATSBY_GIGPRO_APP_URL || 'https://biz.qwick.com/',
  support: 'https://support.qwick.com/en',
  // Smart app link for the Minute / at-home campaign — one URL that routes each
  // visitor to the correct store; used for both store badges on /at-home.
  atHomeAppLink: 'https://applink.qwick.com/at-home',
  // TODO: real URL once developer.qwick.com goes live
  developerDocs: '#',
  proIosAppStore:
    'https://apps.apple.com/us/app/qwick-for-professionals/id1458652766',
  proGoogleAppStore:
    'https://play.google.com/store/apps/details?id=com.qwickmobile&hl=en_US',
  bizReferral: 'https://biz.qwick.com/referral',
  proImpactReferral: 'gigproapp://impact-referral',
  referralRules: 'https://www.gigpro.com/referral-rules',
}

export const INTERNAL_GIGPRO_LINKS = {
  apps: `${COMPANY_URL}/pros`,
  contact: `${COMPANY_URL}/contact`,
}

/**
 * Refs to pages and section anchors within this marketing site. Each entry
 * carries the page's `urlPath` and (when it points at a section anchor) the
 * `slug` of the `<Section>` to scroll to. Page-only entries omit
 * `sectionSlug`. Consumers compose these into a `SiteLink` with
 * `page` + (optional) `pageSection`, which routes through Gatsby `<Link>`.
 */
export const INTRASITE_LINKS = {
  home: {
    pagePath: '/',
  },
  connectComingSoon: {
    pagePath: '/connect/coming-soon-near-me',
  },
  hire: {
    pagePath: '/hire',
  },
  integrationsDirectory: {
    pagePath: '/integrations',
    sectionSlug: 'directory',
  },
  intelligenceAiSuite: {
    pagePath: '/intelligence',
    sectionSlug: 'suite',
  },
  onboardingPipeline: {
    pagePath: '/onboarding',
    sectionSlug: 'pipeline',
  },
  multiUnitMarketplace: {
    pagePath: '/multi-unit',
    sectionSlug: 'marketplace',
  },
  multiUnitCompliance: {
    pagePath: '/multi-unit',
    sectionSlug: 'compliance',
  },
  payFlow: {
    pagePath: '/pay',
    sectionSlug: 'flow',
  },
  enterprise: {
    pagePath: '/enterprise',
  },
  marketplace: {
    pagePath: '/marketplace',
  },
  onboarding: {
    pagePath: '/onboarding',
  },
  pay: {
    pagePath: '/pay',
  },
  compliance: {
    pagePath: '/compliance',
  },
  eventsContact: {
    pagePath: '/events',
    sectionSlug: 'contact',
  },
  qwickgo: {
    pagePath: '/go',
  },
  intelligence: {
    pagePath: '/intelligence',
  },
  events: {
    pagePath: '/events',
  },
  integrations: {
    pagePath: '/integrations',
  },
  blog: {
    pagePath: '/blog',
  },
  caseStudies: {
    pagePath: '/case-studies',
  },
  whitepapers: {
    pagePath: '/whitepapers/',
  },
  robotics: {
    pagePath: '/robotics',
  },
  mission: {
    pagePath: '/mission/',
  },
  careers: {
    pagePath: '/careers/',
  },
  referral: {
    pagePath: '/referral/',
  },
  multiUnit: {
    pagePath: '/multi-unit',
  },
  industryRestaurantsAndBar: {
    pagePath: '/industry/restaurants-and-bar/',
  },
  industryCatering: {
    pagePath: '/industry/catering/',
  },
  industryHotels: {
    pagePath: '/industry/hotels/',
  },
  industryCountryClubs: {
    pagePath: '/industry/country-clubs/',
  },
  industrySeniorLiving: {
    pagePath: '/industry/senior-living/',
  },
  industryQsrs: {
    pagePath: '/qsrs/',
  },
  industryEventVenues: {
    pagePath: '/industry/event-venues/',
  },
  industryCorporateDining: {
    pagePath: '/industry/corporate-dining/',
  },
  industryFoodserviceManagement: {
    pagePath: '/industry/foodservice-management/',
  },
  industryStadiums: {
    pagePath: '/industry/stadiums/',
  },
  industryEventManagement: {
    pagePath: '/industry/event-management/',
  },
  industryCasinos: {
    pagePath: '/industry/casinos/',
  },
  marketplaceHero: {
    pagePath: '/marketplace',
    sectionSlug: 'hero',
  },
  findShifts: {
    pagePath: '/find-shifts',
  },
  professionals: {
    pagePath: '/professionals',
  },
  professionalsHowItWorks: {
    pagePath: '/professionals',
    sectionSlug: 'how-it-works',
  },
  smb: {
    pagePath: '/smb',
  },
  browsePros: {
    pagePath: '/browse-pros/',
  },
  maraAi: {
    pagePath: '/ai/mara',
  },
  ameliaAi: {
    pagePath: '/looqnufs/amelia',
  },
  comingSoonNearMe: {
    pagePath: '/connect/coming-soon-near-me',
  },
  candlelight: {
    pagePath: '/candlelight/',
  },
  diningInTheDark: {
    pagePath: '/dining-in-the-dark/',
  },
  dinosAlive: {
    pagePath: '/dinos-alive/',
  },
  droneArtShow: {
    pagePath: '/drone-art-show/',
  },
  sensoryFeast: {
    pagePath: '/sensory-feast/',
  },
  theJuryExperience: {
    pagePath: '/the-jury-experience/',
  },
  weCallIt: {
    pagePath: '/we-call-it/',
  },
  neonBrush: {
    pagePath: '/neon-brush-paint-in-the-dark/',
  },
}
